import React from 'react';
import PhoneInput from 'react-phone-input-2';
import { Controller } from 'react-hook-form';
import 'react-phone-input-2/lib/style.css';
import { useIntl } from 'react-intl';

const CustomPhoneInput = ({
  wrapperClass = '',
  lableClass = '',
  label = '',
  placeholder = '',
  name,
  control,
  rules,
  value = '',
  defaultValue = '',
  disabled = false,
  error,
}) => {
  const translate = useIntl();
  const getErrorText = (e) => {
    switch (e.type) {
      case 'required':
        return translate.formatMessage({ id: 'acc.field-required' });
      case 'validPhoneNumber':
        return translate.formatMessage({ id: 'acc.invalid-required' });
      default:
        return translate.formatMessage({ id: 'acc.other-required' });
    }
  };

  return (
    <div className={`phone-input ${wrapperClass}`}>
      {label && <p className={`phone-input__label ${lableClass}`}>{label}</p>}
      <Controller
        as={PhoneInput}
        name={name}
        control={control}
        rules={rules}
        defaultValue={defaultValue}
        country="us"
        containerClass={error ? 'phone-input__error' : ''}
        placeholder={placeholder}
        value={value}
        disabled={disabled}
        countryCodeEditable={false}
      />
      {error && <div className="phone-input__error-text">{getErrorText(error)}</div>}
    </div>
  );
};

export default CustomPhoneInput;
